import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Image_Fragment } from "#/graphql/shopify-storefront/fragments/image";

export const ProductVariant_Fragment = graphqlShopifyStorefront(
  `
  fragment ProductVariant on ProductVariant {
    availableForSale
    barcode
    currentlyNotInStock
    id
    image {
      ...Image
    }
    price {
      amount
      currencyCode
    }
    requiresShipping
    taxable
    title
    selectedOptions {
      name
      value
    }
    sku
    weight
  }
`,
  // [Image_Fragment],
);
